/* eslint-disable import-x/no-mutable-exports */
import baseAxios, { AxiosInstance } from 'axios';
import { REQUEST_TIMEOUT_DEADLINE } from 'constants/settings';
import { Agent as HttpAgentInstance } from 'http';
import { Agent as HttpsAgentInstance } from 'https';

let axios: AxiosInstance;
let httpAgent: HttpAgentInstance;
let httpsAgent: HttpsAgentInstance;

if (__SERVER__) {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const HttpAgent = require('agentkeepalive');
  const { HttpsAgent } = HttpAgent;

  httpAgent = new HttpAgent();
  httpsAgent = new HttpsAgent();

  axios = baseAxios.create({
    httpAgent,
    httpsAgent,
    timeout: REQUEST_TIMEOUT_DEADLINE,
  });
} else {
  axios = baseAxios.create({
    timeout: REQUEST_TIMEOUT_DEADLINE,
  });
}

export { axios, httpAgent, httpsAgent };
